import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { TableRow, TableCell, Table, TableHead, TableBody, Grid } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import { withRights } from 'providers/RightsConsumer';
import OfferPartnerMonthlyObligationsItem from './OfferPartnerMonthlyObligationsItem';
import { RightsContext } from 'providers/RightsContext';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { GridActionsWrapper } from 'components/common/CommonStyles';

const OfferPartnerMonthlyObligationsList = ({ t, data, editable, onEdit, onSave, saving, onPropertyItemChange, rights }) => {
  const { isImage } = useContext(RightsContext);

  return (
    <CardNoResultsWrapper content={data}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align='right'>{t('OfferEdit.Client.MonthlyObligations.Value')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((x, idx) => {
                return (
                  <OfferPartnerMonthlyObligationsItem
                    key={x.partnerIncomeSourceDetailId}
                    idx={idx}
                    item={x}
                    editable={editable}
                    onPropertyChange={onPropertyItemChange(idx)}
                  />
                );
              })}
            </TableBody>
          </Table>
        </Grid>
        {!isImage && (
          <GridActionsWrapper mt={2}>
            {data.length > 0 && (
              <Button
                id={'offerPartnerMonthlyObligationsCard_changeBtn'}
                color='primary'
                variant='contained'
                onClick={onEdit}
                disabled={rights.isReadOnly || !rights.clientMonthlyObligationsWrite || editable}
              >
                {t('Change')}
              </Button>
            )}
            <Button
              id={'offerPartnerMonthlyObligationsCard_saveBtn'}
              color='primary'
              variant='contained'
              onClick={onSave}
              disabled={rights.isReadOnly || !rights.clientMonthlyObligationsWrite || saving || !editable}
            >
              {saving ? t('Saving') : t('Save')}
            </Button>
          </GridActionsWrapper>
        )}
      </Grid>
    </CardNoResultsWrapper>
  );
};

OfferPartnerMonthlyObligationsList.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.array,
  editable: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onPropertyItemChange: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};

export default compose(withTranslation())(withRights(OfferPartnerMonthlyObligationsList));
